<template>
  <div class="contentBox">
    <navBox :id="navId"  ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader ref="myHeader"></myHeader>
      <div class="MobelBox videoMobel" v-if="addType">
        <div class="write-txt">
          <p class="write-title">课程标题<span>*</span></p>
          <div class="write-text">
            <textarea placeholder="" v-model="addObj.title"></textarea>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">课程说明<span>*</span></p>
          <div class="write-text">
            <textarea placeholder="" v-model="addObj.desc"></textarea>
            <span>最多输入30个以内的中文</span>
          </div>
        </div>
        <div class="write-txt"  v-loading="loadingImg" :element-loading-text="loadTxt">
          <p class="write-title">课程封面</p>
          <div class="write-text">
            <div style="display:inline-block;">
              
              <div class="img" v-if="addObj.image" >
                <img :src="'https://speakiopic.zens10.com/'+addObj.image" alt="">
                
              </div>
            </div>
            <el-upload
              :action="'https://up-as0.qiniup.com'"
              :data="uploadObj"
              :accept="'image/png,image/jpeg,image/jpg,image/gif'"
              list-type="picture-card"
              :before-upload="beforeUploadImg"
              :on-success="(response, file, fileList)=>{return handleSuccessImg(response, file, fileList)}"
              :on-progress="handleProgressImg"
              :on-remove="handleRemoveVideo"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img
                width="100%"
                :src="'https://speakiopic.zens10.com/' + addObj.image"
                alt=""
              />
            </el-dialog>
          </div>
        </div>
        <div style="display:block;"  v-loading="loading" :element-loading-text="loadTxt">
          <div v-for="(item,index) in addObj.sub" :key="index" class="video-item">
            <div class="video-title">视频{{(index+1)}}: <button v-if="index>0" class="btn btn-item-remove" @click="removeList(index)">删除</button> </div>
            <div class="write-txt">
              <p class="write-title">视频名称<span>*</span></p>
              <div class="write-text">
                <textarea placeholder="" v-model="item.title"></textarea>
                <span>最多输入30个以内的中文</span>
              </div>
            </div>
            <div class="write-txt">
              <p class="write-title">视频说明<span>*</span></p>
              <div class="write-text">
                <textarea placeholder="" v-model="item.desc"></textarea>
                <span>最多输入30个以内的中文</span>
              </div>
            </div>

            <div class="write-txt">
              <p class="write-title">上传视频<span>*</span></p>
              <div class="write-text">
                <div class="img" @mouseenter="imgShow" @mouseleave="imgHide" v-if="item.video">
                  <video :src="'https://speakiopic.zens10.com/'+item.video" alt=""></video>
                  <div class="hover" v-if="imgType">
                    <i class="icon-delete" @click="imgRemove"></i>
                  </div>
                </div>
                <!-- <el-upload
                  :action="'https://upload.qiniup.com'"
                  :data="uploadObj"
                  list-type="picture-card"
                  :before-upload="beforeUploadVideo"
                  :on-success="(response, file, fileList)=>{return handleSuccessVideo(response, file, fileList,index,'num')}"
                  :on-progress="handleProgressImg"
                  :on-remove="handleRemoveVideo"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img
                    width="100%"
                    :src="'https://pic.bi-rong.com/' + item.video"
                    alt=""
                  />
                </el-dialog> -->
                <el-upload
                  class="upload-demo"
                  action="https://up-as0.qiniup.com" 
                  :data="uploadObj"
                  :show-file-list="false"
                  :on-progress="handleProgressImg"
                  :on-success="(response, file, fileList)=>{return handleSuccessVideo(response, file, fileList,index)}"
                  :before-upload="beforeUploadVideo"
                  >
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </div>
            </div>


            <div class="write-txt">
              <p class="write-title">是否免费<span>*</span></p>
              <div class="write-text">
                <el-radio-group v-model="item.is_free">
                  <el-radio label="0">否</el-radio>
                  <el-radio label="1">是</el-radio>
                </el-radio-group>
              </div>
            </div>
            
          </div>
        </div>


        <button class="btn btn-video-add" @click="videoAdd">添加视频</button>
        

        <div class="write-btnBox">
          <button class="btn btn-save" @click="saveSub">保存</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
      
      <div class="organiza-txt" v-else>
        <div class="organiza-title clear">
          <div class="organiza-left" @click="addSub">
            <img src="~@/assets/images/icon-add.png" alt="">
            <p>添加课程</p>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.id">{{item.id}}</p>
              <p :title="item.title">{{item.title}}</p>
              <p :title="item.num">{{item.num}}</p>
              <p>
                 <el-switch
                  @change="switchChange(item)"
                  v-model="item.status"
                  active-color="#457AFF"
                  inactive-color="#CBCBCB">
                </el-switch>
              </p>
              <p :title="item.create_time">{{item.create_time}}</p>
              <p>
                <button title="修改" class="btn btn-revise" @click="buildSub(item)"></button>
                <button title="删除" class="btn btn-remove" @click="removeShow(item)"></button>
              </p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>

      
    </div>

    <div class="msgBox" v-if="removeType">
      <div class="contv">
        <p class="title">是否确定删除？</p>
        <div class="btnBox">
          <button class="btn btn-close" @click="ModelHide('remove')">取消</button>
          <button class="btn btn-sub" @click="removeSub">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCourseList,saveCourse,delCourse,getCourseDetail ,getUploadToken,updateCourseStatus } from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
export default {
  name: "index",
  data() {
    return {
      navId:'17',
      titleList:[
        {id:1,title:'ID'},
        {id:2,title:'课程标题'},
        {id:3,title:'视频总数'},
        {id:4,title:'状态'},
        {id:5,title:'添加时间'},
        {id:6,title:'操作'},
      ],
      dataList:[
      ],
      addType:'',
      removeType:false,
      token:'',
      obj:{
        page:1,
        rows:10
      },
      addObj:{
        title:'',
        image:'',
        desc:'',
        sub:[
          {title:'',video:'',desc:'',length:'',is_free:'0'}
        ]
      },
      totalPage:0,
      removeID:'',
      url:'',
      fileUrl:'/static/词库导入表.xlsx',
      typelist:[
        {id:1,title:'费曼练习'},
        {id:2,title:'30秒黄金自我介绍'},
        {id:3,title:'备稿演讲'},
        {id:4,title:'即兴演讲'},
        {id:5,title:'演讲评估'},
        {id:6,title:'AI改稿'},
      ],
      promptlist:[
        {id:1,title:'文本'},
        {id:2,title:'视频'},
        {id:3,title:'录音'},
      ],
      wordType:false,
      wordObj:{
        words:[
          {title:'',keyword:'',language:1}
        ]
      },
      uploadObj: {
        token: "",
        key: "",
      },
      uploadUrl: "",
      loading:false,
      loadTxt:'',
      dialogVisible:false,
      imgType:false,
      loadingImg:false,
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    this.token = localStorage.getItem('token');
    this.url = this.$refs.navBox.url;
    this.getList();
    this.getToken();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    async getToken(){
      var that = this;
      try {
        const response = await getUploadToken(this.token);
        if(response.code == 200){
          that.uploadObj.token = response.data.token
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      };
      
    },

    async getList(){
      var that = this;
      try {
        const response = await getCourseList(this.obj,this.token);
        if(response.code == 200){
          response.data.list.forEach(function(item,index){
            if(item.status==0){
              item.status=false
            } else {
              item.status=true
            }
          })
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async switchChange(e) {
      var that = this;
      var obj = {
        id:e.id,
        status:e.status==false?0:1,
      };
      try {
        const response = await updateCourseStatus(obj,this.token);
        if(response.code == 200){
          that.$message('发布状态修改成功！');
        } else {
          that.$message(response.msg);
          e.status = !e.status;
        }
      } catch (error) {
        that.$message(error);
        e.status = !e.status;
      }
    },

    addSub(){
      var that = this;
      this.addType = 'add';
    },

    async buildSub(e){
      var that = this;
      try {
        const response = await getCourseDetail({id:e.id},this.token);
        if(response.code == 200){
          that.addObj =  response.data;
          response.data.sub.forEach(function(item,index){
            item.is_free = JSON.stringify(item.is_free)
          })
          that.addType = 'edit';
          console.log(that.addObj.sort)
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
      
    },

    removeShow(e){
      this.removeID = e.id;
      this.removeType = true;
    },

    async removeSub(){
      var that = this;
      try {
        const response = await delCourse({id:this.removeID},this.token);
        if(response.code == 200){
          that.$message('删除成功');
          that.getList();
          that.ModelHide('remove');       
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    ModelHide(type){
      var that = this;
      if(type == 'remove'){
        that.removeType = false;
        taht.removeID = '';
      }
    },

    async saveSub(){
      var that = this;
      if(this.addObj.title == ''){
        that.$message('请输入课程标题！');
        return false;
      }
      if(this.addObj.desc == ''){
        that.$message('请输入课程说明！');
        return false;
      }
      
      try {
        const response = await saveCourse(this.addObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.closeSub();
          that.getList();        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    closeSub(){
      this.addType = '';
      this.addObj = {
        title:'',
        image:'',
        desc:'',
        sub:[
          {title:'',video:'',desc:'',length:'',is_free:'0'}
        ]
      };
    },

    beforeUploadVideo(file) {
      // this.loading = true;
      // this.uploadObj.key = file.uid + file.name; // key为上传后文件名 必填

      const isVideo = file.type.startsWith('video/');
      if (!isVideo) {
        this.$message('只能上传视频文件！');
        return false;
      }
      
      const maxSize = 500 * 1024 * 1024;
      if (file.size > maxSize) {
        this.$message('视频大小不能超过 500MB！');
        return false;
      }
      
      if (!this.uploadObj.token) {
        this.$message('获取上传凭证失败，请刷新页面重试');
        this.getToken();
        return false;
      }
      
      this.loading = true;
      this.loadTxt = '上传中...';
      this.uploadObj.key = file.uid + '_' + file.name;
      
      return true;
    },

    handleSuccessVideo(response, file, fileList,index,type) {
      // this.addObj.sub[index].video = response.key;
      // this.loading = false;
      // this.uploadObj.key = "";

      const videoUrl = 'https://speakiopic.zens10.com/' + response.key;
      const video = document.createElement('video');
      video.preload = 'metadata';
      video.src = videoUrl;
      
      video.onloadedmetadata = () => {
        // const duration = video.duration; 
        const duration = Math.round(video.duration); // 获取视频时长（秒）
        this.addObj.sub[index].video = response.key;
        this.addObj.sub[index].length = duration; // 保存时长
        this.loading = false;
        this.uploadObj.key = "";
      };
      
      video.onerror = () => {
        this.$message('获取视频时长失败');
        this.loading = false;
      };
    },

    handleProgressImg(event, file, fileList) {
      this.loadTxt = "已上传" + file.percentage.toFixed(0) + "%";
    },

    handleRemoveVideo(response, file, fileList,index) {
      this.addObj.video = "";
    },

     beforeUploadImg(file) {
      // this.loadingImg = true;
      // this.loadTxt = '上传中...';
      // this.uploadObj.key = file.uid + file.name; // key为上传后文件名 必填

      // 检查文件类型
      const isImage = file.type.startsWith('image/');
      if (!isImage) {
        this.$message('只能上传图片文件！');
        return false;
      }
      
      // 检查文件大小（如限制 10MB）
      const maxSize = 10 * 1024 * 1024;
      if (file.size > maxSize) {
        this.$message('图片大小不能超过 10MB！');
        return false;
      }
      
      // 检查 token 是否存在
      if (!this.uploadObj.token) {
        this.$message('获取上传凭证失败，请刷新页面重试');
        this.getToken();
        return false;
      }
      
      this.loadingImg = true;
      this.loadTxt = '上传中...';
      this.uploadObj.key = file.uid + '_' + file.name;
      
      return true; // ✅ 必须返回 true 允许上传
    },

    handleSuccessImg(response, file, fileList) {
      // this.addObj.image = response.key;
      // this.loadingImg = false;
      // this.uploadObj.key = "";
      // this.loadTxt = '';
      // this.$forceUpdate();

      this.loadingImg = false;
      this.uploadObj.key = "";
      this.loadTxt = '';
      
      if (response.code == 200 || response.key) {
        this.addObj.image = response.key;
        this.$message('上传成功');
        this.$forceUpdate();
      } else {
        this.$message(response.msg || '上传失败');
      }
    },

    imgShow(){
      this.imgType = true;
    },

    imgHide(){
      this.imgType = false;
    },

    imgRemove(){
      if(this.headID == 1){
        this.ExerSet.img = '';
      } else {
        this.TestSet.img = '';
      };
    },
    
    videoAdd(){
      this.addObj.sub.push({title:'',video:'',desc:'',length:'',is_free:'0'})
    },

    removeList(index){
      this.addObj.sub.splice(index,1);
    }
  }

  
};
</script>
<style scoped>
  .dataList .listItem p, 
  .organiza-list p{
    width: calc( 100% / 6 );
  }

  .btn-remove,
  .btn-revise{
    background-image: url(~@/assets/images/btn-revise.png);
    width: 22px;
    height: 22px;
    background-size: 22px 22px;
    display: inline-block;
    vertical-align: top;
  }

  .btn-remove{
    background-image: url(~@/assets/images/btn-remove.png);
    margin-left: 50px;
  }

  .MobelBox{
    padding: 40px;
    box-sizing: border-box;
    width: 100%;
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-title{
    font-size: 18px;
    color: #333333;
    display: inline-block;
    vertical-align: top;
  }

  .MobelBox .write-title span{
    color: #E2231A;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
  }

  .MobelBox .write-text span{
    font-size: 14px;
    color: #E2231A;
    margin-top: 10px;
    display: block;
  }

  .MobelBox input,
  .MobelBox textarea{
    width: 80%;
    height: 65px;
    background-color: #F5F5F5;
    border-radius: 16px;
    display: block;
    padding: 10px;
    box-sizing: border-box;
  }
  
  .MobelBox input{
    height: 45px;
    width: 200px;
  }

  .write-btnBox{
    float: right;
    width: 100%;
    text-align: right;
  }

  .write-btnBox .btn{
    width: 120px;
    height: 56px;
    line-height: 56px;
    border-radius: 16px;
    color: #fff;
    background-color: #6E2FFF;
    padding: 0;
    margin: 0;
    font-size: 20px;
  }

  .write-btnBox .btn.btn-close{
    color: #999999;
    background-color: #F5F5F5;
    margin-left: 40px;
  }

  .msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

  .msgBox .title {
    text-align: center;
    margin-bottom: 50px;
  }

  .btn-import{
    display: inline-block;
    vertical-align: top;
  }

  .organiza-txt>>>.el-upload{
    width: 100%;
    display: block;
  }

  .organiza-txt>>>.el-button--small span{
    width: 100%;
    text-align: center;
    display: block;
  }

  .organiza-txt>>>.el-button--primary{
    background-color: transparent;
    border: none;
    font-size: 15px;
  }

  .btn-word-add{
    color: #6E2FFF;
    border: solid 1px #6E2FFF;
    border-radius: 8px;
    padding: 11px 34px;
    display: block;
    margin-top: 30px;
    font-size: 18px;
  }

  .btn-word-remove{
    background-color: #E2231A;
    border-radius: 8px;
    color: #fff;
    box-sizing: border-box;
    padding: 11px 52px;
    display: inline-block;
    vertical-align: middle;
    font-size: 18px;
  }

  .wordBox{
    height: calc( 100% - 100px );
  }

  .wordBox .word-item{
    margin-bottom: 20px;
    display: block;
    background-color: #fff;
    box-sizing: border-box;
    padding: 40px 30px;
  }

  .video-item{
    display: block;
    background-color: #fff;
    border-radius: 16px;
    margin: 20px 0;
    box-sizing: border-box;
    padding: 30px;
  }

  .video-title{
    font-size: 18px;
    color: #333333;
    display: block;
    margin: 0 0 30px 0;
  }

  .videoMobel{
    height: calc( 100% - 80px );
  }

  .video-item>>> .el-radio__inner{
    width: 18px;
    height: 18px;
  }
  .video-item>>> .el-radio__label{
    font-size: 18px;
  }

  .btn-video-add{
    color: #6E2FFF;
    font-size: 18px;
    border-radius: 8px;
    border: solid 1px #6E2FFF;
    display: block;
    margin-top: 30px;
    box-sizing: border-box;
    padding: 10px 35px;
  }

  .btn-item-remove{
    font-size: 18px;
    color: #fff;
    background-color: #E2231A;
    border-radius: 8px;
    display: inline-block;
    padding: 10px 20px;
    box-sizing: border-box;
    margin-left: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/course/index.vue